"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDateTimeCell = void 0;
const date_time_field_1 = require("../../../components/date-time-field/date-time-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
/**
 * @deprecated
 *
 * Use FilterInstantCell instead.
 */
exports.FilterDateTimeCell = filter_interval_cell_factory_1.filterIntervalCellFactory(date_time_field_1.DateTimeField);
//# sourceMappingURL=filter-date-time-cell.js.map